import { render, staticRenderFns } from "./tipiParametri.vue?vue&type=template&id=70f7b1f1&"
import script from "./tipiParametri.vue.ts?vue&type=script&lang=ts&"
export * from "./tipiParametri.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports